import React, { useState } from 'react';
import { Modal, Input } from 'antd';
import { Button, Select, SelectOption } from '../../../components/ui';
import { useCreateDedicatedIp } from '../../../mutation/dedicatedIp';
import { SEND_THROUGH_LIST } from '../../../constants/common';
import { useForm, Controller } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import * as Joi from 'joi';

const schema = Joi.object().keys({
  ip: Joi.string().ip({ version: 'ipv4' }),
  esp: Joi.string().required(),
});

export default function CreateDedicatedIpButton() {
  const [showModal, setShowModal] = useState(false);
  const { isLoading, mutate } = useCreateDedicatedIp();
  const { control, handleSubmit } = useForm({
    mode: 'onChange',
    defaultValues: {
      esp: -1,
      ip: '',
    },
    resolver: joiResolver(schema),
  });
  return (
    <>
      <Button
        loading={isLoading}
        type="button"
        onClick={() => setShowModal(true)}
      >
        Add Dedicated IP
      </Button>
      <Modal
        title="Create new Dedicated IP"
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={handleSubmit(values => {
          setShowModal(false);
          mutate(values);
        })}
      >
        <Controller
          control={control}
          name="esp"
          render={({ field: { value, onChange, onBlur } }) => {
            return (
              <div className="w-full">
                <p className="input-name">Email Service Provider</p>
                <Select
                  className="w-full"
                  value={value}
                  onBlur={onBlur}
                  onChange={onChange}
                >
                  <SelectOption key="default" value={-1}>
                    Select an ESP
                  </SelectOption>
                  {SEND_THROUGH_LIST.map(sendThrough => (
                    <SelectOption key={sendThrough} value={sendThrough}>
                      {sendThrough}
                    </SelectOption>
                  ))}
                </Select>
              </div>
            );
          }}
        />
        <Controller
          control={control}
          name="ip"
          render={({ field: { value, onChange, onBlur } }) => {
            return (
              <div style={{ marginTop: 10 }}>
                <p className="input-name">IP Address</p>
                <Input value={value} onBlur={onBlur} onChange={onChange} />
              </div>
            );
          }}
        />
      </Modal>
    </>
  );
}
